import "./dashboard-sections.css";
import DashboardCard from "./DashboardCard";

const DUMMY = {
  actual_paid_kg_case:  "18.5 kg",
  difference_paid_pct:  "3.2%",
  total_prime_pct:      "72.0%",
  real_kg_case:         "17.9 kg",
  real_kg_case_prime:   "12.9 kg",
};

const EvapBox = ({ label, value, isLoading = false }) => (
  <div className="db-evap-box">
    <div className="db-evap-label">{label}</div>
    <div className="db-evap-value neutral">
      {isLoading
        ? <span className="db-shimmer" style={{ height: 24, width: 60, display: "block" }} />
        : (value ?? "—")
      }
    </div>
  </div>
);

const FruitQualityMetrics = ({ data = DUMMY, isLoading = false }) => (
  <DashboardCard title="Fruit Quality Metrics">
    <div className="db-evap-row">
      <EvapBox label="ACTUAL PAID W/ RIPENING WASTE" value={data?.actual_paid_kg_case} isLoading={isLoading} />
      <EvapBox label="PAID % GOING INTO PROCESSING"  value={data?.difference_paid_pct} isLoading={isLoading} />
      <EvapBox label="TOTAL PRIME %"                 value={data?.total_prime_pct}     isLoading={isLoading} />
      <EvapBox label="REAL KG/CASE"                  value={data?.real_kg_case}        isLoading={isLoading} />
      <EvapBox label="REAL KG/CASE PRIME"            value={data?.real_kg_case_prime}  isLoading={isLoading} />
    </div>
  </DashboardCard>
);

export default FruitQualityMetrics;
